import React from 'react';
import { useFolders } from '@/core/hooks/useFolders';
import type { Folder } from '../../../../types';
import { flattenFoldersFromArchive } from './utils/flattenFolders';

type Params = {
  archiveId?: string;
  currentFolderId?: string;
};

export function useMoveIntoFolderLogic({ archiveId, currentFolderId }: Params) {
  const { archive, loading } = useFolders(archiveId ?? '');

  const [search, setSearch] = React.useState('');
  const [selectedId, setSelectedId] = React.useState<string | null>(null);

  const folders: Folder[] = React.useMemo(() => {
    return flattenFoldersFromArchive(archive, archiveId);
  }, [archive, archiveId]);

  const filtered: Folder[] = React.useMemo(() => {
    const term = search.trim().toLowerCase();
    const base = currentFolderId ? folders.filter((f) => f.id !== currentFolderId) : folders;
    if (!term) return base;
    return base.filter((f) => f.name.toLowerCase().includes(term));
  }, [folders, search, currentFolderId]);

  return {
    loading,
    search,
    setSearch,
    selectedId,
    setSelectedId,
    folders,
    filtered,
  } as const;
}
